<template>
    <div @click="showMessage" class="message-con">
        <Tooltip :content="value > 0 ? '有' + value + '条未读消息' : '无未读消息'" placement="bottom">
            <Badge :count="value" dot>
                <Icon type="ios-bell" :size="22"></Icon>
            </Badge>
        </Tooltip>
    </div>
</template>

<script>
import util from '../../libs/util.js';
import PageName from '../../constant/PageName';
export default {
    name: 'messageTip',
    props: {
        value: {
            type: Number,
            default: 0
        }
    },
    methods: {
        showMessage () {
            util.openNewPage(this, PageName.PAGE_MESSAGE_INDEX);
            this.$router.push({
                name: PageName.PAGE_MESSAGE_INDEX
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/main-components/message-tip.vue